import {useQuery} from "@tanstack/react-query";
import {useParams} from "react-router-dom";
import {getLeadersBulletin} from "./getLeadersBulletin";
import axios from "../../axios";

export function useGetLeadersBulletin() {
  const {eventId} = useParams<{eventId: string}>();

  return useQuery({
    queryKey: ["leadersBulletin", eventId],
    queryFn: async () => {
      if (!eventId) throw new Error("Event id is required");
      const response = await getLeadersBulletin(
        {data: {eventId: parseInt(eventId)}},
        axios
      );
      return response;
    },
    enabled: !!eventId,
    retry: false,
    throwOnError: true,
  });
}
